import { AddItemButton } from './AddItemButton.jsx';
import styles from './RepeatableFormFields.module.css';
import { RemoveItemButton } from './RemoveItemButton.jsx';

export function RepeatableFormFields({
  items,
  onAddItem,
  onRemoveItem,
  children,
}) {
  return (
    <>
      {items.map((item, key) => (
        <div key={key} className={styles.item}>
          <RemoveItemButton onClick={() => onRemoveItem(key)} />
          {children(item, key)}
        </div>
      ))}
      <AddItemButton onClick={onAddItem} />
    </>
  );
}
